// Empty screen for standby / hidden modes (doc §12.3). Intentionally renders
// nothing visible so OBS shows a transparent/empty overlay.
export function StandbyScreen() {
  return <div className="display-standby" aria-hidden="true" />;
}
